/**
 * RMA processing form — customer / site-group special-instruction
 * acknowledgements plus the reporting-contact selector.
 *
 * The two instruction toggles gate form submission upstream; the
 * reporting contact seeds the RMA's support-contact fields.
 *
 * Contains:
 * - InstructionsReportingSection (default export)
 */

import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ContactSelector } from '@sophocles/components/contacts';
import SpecialInstructionsCollapse from '@sophocles/views/returns/components/CustomerSpecialInstructionsCollapse';
import SiteGroupInstructionsCollapse from '@sophocles/views/returns/components/SiteGroupInstructionsCollapse';

import { SectionCard } from '../../components/ReturnSection';

export default function InstructionsReportingSection({
  customerId,
  siteGroupId,
  customer,
  siteGroup,
  selectedReportingContact,
  onReportingContactChange,
  customerSpecialInstructionsFollowed,
  onToggleCustomerInstructions,
  siteGroupInstructionsFollowed,
  onToggleSiteGroupInstructions,
}) {
  const { t } = useTranslation();
  return (
    <SectionCard title={t('rma.instructionsReportingContact', 'Instructions & Reporting Contact')}>
      {customerId !== 0 && (
        <SpecialInstructionsCollapse
          customer={customerId}
          types={[1, 3]}
          checked={customerSpecialInstructionsFollowed}
          onToggle={onToggleCustomerInstructions}
        />
      )}
      {siteGroupId !== 0 && (
        <SiteGroupInstructionsCollapse
          siteGroup={siteGroupId}
          types={[1, 3]}
          checked={siteGroupInstructionsFollowed}
          onToggle={onToggleSiteGroupInstructions}
        />
      )}

      <Box sx={{ mb: 2 }}>
        <ContactSelector
          value={selectedReportingContact}
          onChange={onReportingContactChange}
          customerId={customerId}
          siteGroupId={siteGroupId}
          customer={customer}
          siteGroup={siteGroup}
          label={t('rma.reportingContact', 'Reporting Contact')}
          showAddress={false}
          required={false}
          quickMode={true}
          requireCompleteAddress={false}
          requiredFields={['email', 'name']}
          primaryContext="rma"
          contextLabel={t('rma.rma', 'RMA')}
        />
      </Box>
    </SectionCard>
  );
}
